function internalWallet(state = {}, action) {
  switch (action.type) {
    case 'SET_INTERNAL_WALLET':
      return action.wallet;
    default:
      return state;
  }
}

export default internalWallet;
